export default Object.freeze({
  NEW: 'NEW',
  VALIDATED: 'VALIDATED',
  REFUSED: 'REFUSED',
});
